export enum SubStatusKey {
  Connectivity, // displayed 1st
  Authentication,
  Purchase,
  Matchmaking,
  Leaderboard,
}

export enum Status {
  online,
  maintenance,
  interrupted,
  degraded,
}

export interface Ip2Location {
  countryCode: string;
}

export interface PlatformDto {
  AppID: string;
  MDM: string;
  SpaceID: string;
  Category: string;
  Name: string;
  Platform: string;
  Status: string;
  Maintenance: string | null;
  ImpactedFeatures: string[];
  _expanded: boolean;
}

export interface GameStatusesDto {
  applicationId: string;
  spaceId: string;
  name: string;
  platformType: string;
  status: string;
  isMaintenance: boolean | null;
  impactedFeatures: string[];
  _expanded: boolean;
}

export interface GameStatusesResponse {
  gameStatuses: GameStatusesDto[];
  lastModifiesAt: string;
}

export interface NewsItemDto {
  spaceId: string;
  newsId: string;
  title: string;
  body: string;
  publicationDate: string;
  placement: string;
  obj: {
    platform?: string;
  };
}

export interface State {
  platforms: GameStatusesDto[];
  news: NewsItemDto[];
  loadDate: Date;
  locale: string;
  _loadingPlatforms: boolean;
  _loadingNews: boolean;
}

export enum PlatformCode {
  ANDROID = "ANDROID",
  IPAD = "iPad",
  IOS = "IOS",
  PC = "PC",
  WII = "WII",
  WIIU = "WIIU",
  XBOXSX = "XboxScarlett",
  XBOX360 = "360",
  XBOXONE = "DURANGO",
  PS3 = "PS3",
  PS4 = "ORBIS",
  PS5 = "PS5",
  OCULUS = "Facebook",
  SWITCH = "NX",
  LUNA = "AmazonStreaming",
  NVIDIA = "NvidiaStreaming",
  WEB = "WebGame",
}
